import Vue from 'vue';
import Vuex from 'vuex';
import cart from './modules/cart';
import purchaseOrder from './modules/purchaseOrder';
import dashboard from './modules/dashboard';
import auth from './modules/auth';
import message from './modules/message';
import wholesaler from './modules/wholesaler';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    cart,
    purchaseOrder,
    dashboard,
    auth,
    message,
    wholesaler
  }
});